import TextInput from "./TextInputComponent";

export default TextInput;
